<div class="confirm-dialog-wrapper">
    <h1 id="confirmation-header" *ngIf="header">
        {{header}}
    </h1>

    <ng-container *ngIf="target && !targetList">
        <div class="title" [innerHTML]="target"></div>
    </ng-container>

    <ng-container *ngIf="targetList && !useCheckboxList">
        <div class="title">
            <span>{{target}}</span>

            <ul class="target-list">
                <li *ngFor="let listItem of (showDescription && (targetList.length > 3)) ? targetList : targetListShortCopy ">
                    {{listItem}}
                </li>
            </ul>
            <mat-checkbox [(ngModel)]="showDescription" *ngIf="targetList.length > 3" class="show-hide-button">
                <span>{{(showDescription ? ' Hide ' + targetListItem : 'Show ' + (targetList.length - targetListShortCopy.length) + ' more')}}</span>
            </mat-checkbox>
        </div>
    </ng-container>

    <ng-container *ngIf="useCheckboxList">
        <div class="title checkbox-style">
            <div class="title-block">{{target}}</div>

            <ul class="target-list checkbox-list">
                <li *ngFor="let listItem of targetList">
                    <mat-checkbox name="{{listItem[identifierKeyName]}}"
                                  [checked]="true"
                                  (change)="toggleCheckboxList($event, listItem)"
                    >
                            {{listItem[nameKeyName]}}
                    </mat-checkbox>
                </li>
            </ul>
        </div>
    </ng-container>

    <ng-container *ngIf="useAdvancedDeleteConfirmation">
        <form name="formGroup" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <mat-form-field class="dialog-input-field">
                <mat-label>Type Delete to continue</mat-label>
                <input matInput
                       formControlName="deleteConfirm"
                       type="text"
                       [required]="true"
                       ngcAutofocus
                />
            </mat-form-field>
        </form>
    </ng-container>

    <div class="button-row" *ngIf="item=='delete'">
        <button mat-button class="discard-btn mr-8" (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" class="confirm-btn"
                [disabled]="useAdvancedDeleteConfirmation && formGroup?.invalid"
                (click)="onSubmit()">Delete</button>
    </div>

    <div class="button-row" *ngIf="item=='error'">
        <button mat-raised-button color="primary" class="confirm-btn" (click)="onSubmit()">Ok</button>
    </div>

    <div class="button-row" *ngIf="item=='welcomeTour'">
        <button mat-stroked-button class="discard-btn mr-8" (click)="onCancel()">Skip tours</button>
        <button mat-raised-button color="accent" class="confirm-btn" (click)="onSubmit()">Start</button>
    </div>

    <div class="button-row" *ngIf="item=='other'">
        <button mat-button class="discard-btn mr-8" (click)="onCancel()">{{otherItemCancelBtnTitle}}</button>
        <button mat-raised-button color="primary" class="confirm-btn" (click)="onSubmit()">{{otherItemConfirmBtnTitle}}</button>
    </div>
</div>
